export default __webpack_public_path__ + "static/media/11.e3a8b2b4.png";